import SLoader from './SLoader.vue';
import Vue from 'vue';
import { DirectiveOptions } from 'vue/types/options';
import i18n from '@/i18n';

interface ILoaderComponent extends SLoader {
  id?: number;
  show: boolean;
}

const LoaderConstructor = Vue.extend(SLoader);

const Loader: ILoader = ({ show = true, fullPage = false, element }) => {
  const id = Loader.id++;
  const propsData = { show, fullPage, element, id };
  const instance = (new LoaderConstructor({
    propsData,
    i18n,
  }) as ILoaderComponent);
  instance.$mount();
  if (element) element.appendChild(instance.$el);
  Loader.instances.push(instance);
  return instance;
};

// eslint-disable-next-line no-array-constructor
Loader.instances = [];
Loader.id = 0;
Loader.instance = id => Loader.instances.find(loader => loader.id === Number(id));

export default Loader;

export interface ILoader {
  ({ show, fullPage, element }: {show?: boolean; fullPage?: boolean; element: HTMLElement}): ILoaderComponent;
  instances: ILoaderComponent[];
  id: number;
  instance: (id: string | undefined) => ILoaderComponent | undefined;
}

export const LoaderDirective: DirectiveOptions = {
  bind: (el, binding) => {
    const data = {
      element: el,
      show: binding.value,
    };
    const instance = Loader(data);

    el.dataset.id = String(instance.id);
  },
  update: (el, binding) => {
    const instance = Loader.instance(el.dataset.id);
    if (instance) {
      instance.show = binding.value;
    }
  },
  unbind: el => {
    const instance = Loader.instance(el.dataset.id);
    if (instance) instance.$destroy();
  },
};
